const initializeCartFaq = () => {
    if (!$(".js-faq-checkout-container").length)
        return;

    $("body").on("faq:reading", (_, isReadingFaq) => {
        $(".js-faq-modal").toggleClass("faq-modal-reading", isReadingFaq);
    });

    $("body").on("click", ".js-open-faq-button", () => {
        $(".js-faq-checkout-container").addClass("active");
    });

    $("body").on("click", ".js-close-faq-button", closeFaqModal);

    $("body").on("click", ".js-faq-checkout-container", (e) => {
        if ($(e.target).is(".js-faq-checkout-container.active")) {
            closeFaqModal();
        }
    });

    (function faqAccordion() {
        $("body").on("click", ".js-faq-accordion-card-header", (e) => {
            const $accordionCard = $(e.currentTarget).parent();

            $accordionCard.toggleClass("faq-section-active");
            $accordionCard.find("> .faq-accordion__card__body").toggle(300);

            closeAccordions($accordionCard.siblings());
            closeAccordions($accordionCard.siblings().find(".faq-accordion__card"));

            $("body").trigger("faq:reading", hasActiveSessionAccordion());
        });
    })();

    function closeFaqModal() {
        $(".js-faq-checkout-container").removeClass("active");
        closeAllFaqAccordions();
    }

    function hasActiveSessionAccordion() {
        return $(".faq__modal__body > .faq-accordion > .faq-accordion__card.faq-section-active").length > 0;
    }

    function closeAccordions($accordions) {
        $accordions
            .removeClass("faq-section-active")
            .find("> .faq-accordion__card__body")
            .hide(300);
    }

    function closeAllFaqAccordions() {
        $("body").trigger("faq:reading", false);
        $(".faq-accordion > .faq-accordion__card.faq-section-active").removeClass("faq-section-active");
        $(".faq-accordion > .faq-accordion__card > .faq-accordion__card__body").hide();
    }
};

export default initializeCartFaq;
